export interface URMRole {
  label: string,
  key: URMRoleKey,
  description: string,
}

export enum URMRoleKey {
  AccountAdmin = 'account-admin',
  AccountAuthorizedUser = 'account-authorized-user',
  TripBookingUser = 'trip-booking-user',
  TripAuthorizedUser = 'trip-authorized-user',
  TripViewOnly = 'trip-view-only-user',
  TripEditor = 'trip-editor',
  TripContact = 'trip-contact'
}

export namespace URMRoles {
  export const AccountAdmin = {
    label: 'Admin',
    key: URMRoleKey.AccountAdmin,
    description: 'Can add users to the account, create new quotes in the account, and complete checkout using the account\'s default payment method. Can also share quotes/reservations, and modify or cancel.'
  } as URMRole
  export const AccountAuthorizedUser = {
    label: 'Authorized User',
    key: URMRoleKey.AccountAuthorizedUser,
    description: 'Can view all quotes and reservations in the account, share with others and make payments.'
  } as URMRole
  export const TripBookingUser = {
    label: 'Booking Contact',
    key: URMRoleKey.TripBookingUser,
    description: 'Primary owner of the booking who can manage all aspects including modifications, payments, and sharing permissions.'
  } as URMRole
  export const TripAuthorizedUser = {
    label: 'Authorized User',
    key: URMRoleKey.TripAuthorizedUser,
    description: 'Can make payments, share with view-only users, and optionally modify or cancel reservation.'
  } as URMRole
  export const TripViewOnly = {
    label: 'View-Only User',
    key: URMRoleKey.TripViewOnly,
    description: 'Can only view trip details—no modifications, no payments.'
  } as URMRole
  export const TripEditor = {
    label: 'Trip Editor',
    key: URMRoleKey.TripEditor,
    description: 'Can modify this booking.'
  } as URMRole
  export const TripContact = {
    label: 'Trip Contact',
    key: URMRoleKey.TripContact,
    description: 'Can view this booking.'
  } as URMRole
}

export interface UpdateTeamUserRoleRequest {
  customerAccountId: number,
  userRole: URMRoleKey,
}

export interface UserRoleInAccount {
  customerAccountExternalId: string,
  userRole: URMRoleKey,
}
